// extracted by mini-css-extract-plugin
export default {"skeleton":"AntSkeleton_skeleton__mROaB"};